import { omit } from "lodash-es";
import React, { FC, useState } from "react";

import { IconButton, InputAdornment, styled } from "@mui/material";

import { useDispatch } from "../../store";
import { UploadIcon } from "../icons";
import { ReduxTextField, ReduxTextProps } from "./TextField";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

type ImageUrlTextFieldProps = ReduxTextProps;
const ImageUrlTextField: FC<ImageUrlTextFieldProps> = (props) => {
  const { path, setter } = props;
  const dispatch = useDispatch();
  // when a logo is uploaded, remount the redux text field so that it picks up the new value
  const [remount, setRemount] = useState(1);

  const handleUpload = (evt: React.ChangeEvent<HTMLInputElement>) => {
    evt.preventDefault();
    if (!evt.target.files) return;
    const file = evt.target.files[0];
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      dispatch(setter({ path, value: e.target?.result as string }));
      setRemount(remount + 1);
    };
    reader.readAsDataURL(file);
  };

  return (
    <ReduxTextField
      {...omit(props, "key")}
      key={remount}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton component="label" edge="end">
                <UploadIcon />
                <VisuallyHiddenInput type="file" onChange={handleUpload} />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
export default ImageUrlTextField;
